import { render } from "./editCompanyModal.vue?vue&type=template&id=35bb0868&ts=true"
import script from "./editCompanyModal.vue?vue&type=script&lang=ts"
export * from "./editCompanyModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__